import { memo } from "react";

export const RemoveWaveErrorContent = memo(() => {
  return (
    <>
      You cannot remove this wave time while there are still routes associated
      with it. You will need to remove the routes first.
    </>
  );
});
